
	export default function backNav(role) {
		let returnData = [];
	
		if(role==1){
			returnData =
			[
			
				[
					{
						name: '首页',
						key: 'index/index'
					}
				],
				[
					{
						name: '加热大屏',
						key: 'short-video/video-screen/video-screen'
					},
					{
						name: '视频投流',
						key: 'short-video',
						children: [
							{
								name: '投放数据',
								key: 'short-video/launch-data/launch-data',
							},
							{
								name: '素材数据',
								key: 'short-video/material',
							},
							{
								name: '计划包',
								key: 'short-video/plan-package/plan-package',
							},
							{
								name: '创建计划',
								key: 'short-video/create-plan/create-plan',
							},
						
							{
								name: '投放记录',
								key: 'short-video/put-record/put-record',
							},
						],
					},
					{
						name: '批量创建',
						key: 'batchCreatePlan',
						children: [
							{
								name: '创建计划',
								key: 'short-video/batch-create-plan/batch-create-plan',
							},
							{
								name: '投放记录',
								key: 'short-video/batch-create-plan/batch-put-record',
							},
						],
					},
					{
						name: '长期计划',
						key: 'longTermPlan',
						children: [
							{
								name: '投放数据',
								key: 'short-video/long-term-plan/launch-data/launch-data',
							},
							{
								name: '素材数据',
								key: 'short-video/long-term-plan/material',
							},
							{
								name: '计划包',
								key: 'short-video/long-term-plan/plan-package/plan-package',
							},
							{
								name: '创建计划',
								key: 'short-video/long-term-plan/create-plan/create-plan',
							},
							{
								name: '投放记录',
								key: 'short-video/long-term-plan/put-record/put-record',
							}
						],
					},
					// {
					// 	name: '杠杆投流',
					// 	key: 'videoLever',
					// 	children: [
					// 		{
					// 			name: '创建杠杆',
					// 			key: 'short-video/bar/create-plan',
					// 		},
					// 		{
					// 			name: '杠杆记录',
					// 			key: 'short-video/bar/process',
					// 		},
					// 		{
					// 			name: '充值余额',
					// 			key: 'short-video/management/balance',
					// 		},
					// 		{
					// 			name: '余额明细',
					// 			key: 'short-video/management/balance-details',
					// 		},
					// 		{
					// 			name: '余额提现',
					// 			key: 'short-video/withdrawal/withdrawal',
					// 		},
						
					// 	],
					// },
					// {
					// 	name: '视频管理',
					// 	key: 'short-video/video-list/video-list'
					// },
					
					{
						name: '视频号助手',
						key: 'shortAide',
						children: [
							{
								name: '授权管理',
								key: 'short-video/aide/auth',
							},
							{
								name: '视频管理',
								key: 'short-video/aide/video-list',
							},
							{
								name: '自动删评',
								key: 'short-video/aide/auto-del',
							}
							
						],
					},
					
					{
						name: '数据报表',
						key: 'report',
						children: [
							{
								name: '财务报表',
								key: 'short-video/report/finance',
							},
							{
								name: '运营报表',
								key: 'short-video/report/operation',
							}
						],
					},
					{
						name: '投流订单',
						key: 'order',
						children: [
							{
								name: '订单管理',
								key: 'short-video/order/order-management',
							}
						],
					},
					{
						name: '智能助手',
						key: 'auto',
						children: [
							{
								name: '自动关停策略',
								key: 'short-video/auto-close/auto-close',
							}
						],
					}
				],
				[
					{
						name: '加热大屏',
						key: 'live/screen/screen'
					},
					
					{
						name: '直播投流',
						key: 'live',
						children: [
							{
								name: '投放数据',
								key: 'live/launch-data/launch-data',
							},
							{
								name: '智能赔付',
								key: 'live/compensation/compensation',
							},
							{
								name: '计划包',
								key: 'live/plan-package/plan-package',
							},
							{
								name: '创建计划',
								key: 'live/create-plan/create-plan',
							},
							{
								name: '投放记录',
								key: 'live/put-record/put-record',
							}
						],
					},
					{
						name: '直播大屏',
						key: 'assistant',
						children: [
							{
								name: '直播帐号',
								key: 'live/assistant1/assistant-account',
							},
							{
								name: '直播场次',
								key: 'live/assistant1/assistant-data',
							},
							
							{
								name: '数据大屏',
								key: 'live/assistant1/assistant-screen',
							},
						],
					},
					{
						name: '长期计划',
						key: 'promoteLive',
						children: [
							{
								name: '投放数据',
								key: 'live/promote-plan/launch-data/launch-data',
							},
					
							{
								name: '计划包',
								key: 'live/promote-plan/plan-package/plan-package',
							},
							{
								name: '创建计划',
								key: 'live/promote-plan/create-plan/create-plan',
							},
							{
								name: '投放记录',
								key: 'live/promote-plan/put-record/put-record',
							}
						
						],
					},
				{
					name: '数据报表',
					key: 'liveReport',
					children: [
						{
							name: '财务报表',
							key: 'live/report/finance',
						},
						// {
						// 	name: '运营报表',
						// 	key: 'short-video/report/operation',
						// }
					],
				},
				{
					name: '数据分析',
					key: 'live/data-analysis/data-analysis'
				},
				{
					name: '智能助手',
					key: 'liveAuto',
					children: [
						{
							name: '自动关停策略',
							key: 'live/auto-close/auto-close',
						}
					],
				},
				
				// {
				// 	name: '杠杆投流',
				// 	key: 'lever',
				// 	children: [
			
				// 		{
				// 			name: '创建杠杆',
				// 			key: 'live/lever/create-plan',
				// 		},
				// 		{
				// 			name: '杠杆记录',
				// 			key: 'live/lever/process',
				// 		},
				// 		{
				// 			name: '充值余额',
				// 			key: 'live/management/balance',
				// 		},
				// 		{
				// 			name: '余额明细',
				// 			key: 'live/management/balance-details',
				// 		},
				// 		{
				// 			name: '余额提现',
				// 			key: 'live/withdrawal/withdrawal',
				// 		},
					
					
				// 	],
				// }
				
				],
				[
					{
						name: '加热大屏',
						key: 'product-card/video-screen/video-screen'
					},
					{
						name: '商品卡投流',
						key: 'product-card',
						children: [
							{
								name: '投放数据',
								key: 'product-card/launch-data/launch-data',
							},
							{
								name: '素材数据',
								key: 'product-card/material/material',
							},
							{
								name: '计划包',
								key: 'product-card/plan-package/plan-package',
							},
							{
								name: '创建计划',
								key: 'product-card/create-plan/create-plan',
							},
							{
								name: '投放记录',
								key: 'product-card/put-record/put-record',
							},
						],
					},
					{
						name: '数据报表',
						key: 'productCardReport',
						children: [
							{
								name: '财务报表',
								key: 'product-card/report/finance',
							},
						],
					},
					{
						name: '智能助手',
						key: 'productCardAuto',
						children: [
							{
								name: '自动关停策略',
								key: 'product-card/auto-close/auto-close',
							},
						],
					},
				],
				
				[
					{
						name: '数据大屏',
						key: 'shop/shop-screen/shop-screen'
					},
					{
						name: '数据概览',
						key: 'shop/shop'
					},	
					{
						name: '订单管理',
						key: 'shopManagement',
						children: [
							{
								name: '订单列表',
								key: 'shop/order-list/order-list',
							}
						],
					},
					{
						name: '售后管理',
						key: 'shopAfterSale',
						children: [
							{
								name: '售后订单管理',
								key: 'shop/after-sale/order-management',
							},
							{
								name: '退货地址管理',
								key: 'shop/after-sale/return-address-management',
							},
							// {
							// 	name: '自动审核管理',
							// 	key: 'shop/after-sale/automatic-management',
							// },
							{
								name: '客服操作日志',
								key: 'shop/after-sale/automatic-log',
							},
						],
					},
					// {
					// 	name: '商品管理',
					// 	key: 'shopGoodsManagement',
					// 	children: [
					// 		{
					// 			name: '商品数据统计',
					// 			key: 'shop/goods-management/goods-management',
					// 		}
							
					// 	],
					// },
					{
						name: '小店管理',
						key: 'shop/shop-management'
					},	

					{
						name: '爆单预警',
						key: 'shop/burst-order'
					},
					{
						name: '添加小店',
						key: 'shopAdd',
						children: [
							{
								name: '添加小店第一步',
								key: 'shop/shop-add/shop-add-first',
							},
							{
								name: '添加小店第二步',
								key: 'shop/shop-add/shop-add-second',
							}
						],
					},
				],
				// [
				// 	{
				// 		name: '商品推广',
				// 		key: 'vshopPromotionShop',
				// 		children: [
				// 			{
				// 				name: '推广数据',
				// 				key: 'vhop/launch-data/promotion-shop',
				// 			},
				// 			{
				// 				name: '详情',
				// 				key: 'vhop/launch-data/promotion-shop-detail',
				// 			},
				// 			{
				// 				name: '计划包',
				// 				key: 'vhop/launch-data/promotion-shop-plan',
				// 			},
							
				// 		],
				// 	},
				// 	{
				// 		name: '直播推广',
				// 		key: 'vshopPromotionLive',
				// 		children: [
				// 			{
				// 				name: '推广数据',
				// 				key: 'vhop/launch-data/promotion-live',
				// 			},
				// 			{
				// 				name: '数据分析',
				// 				key: 'vhop/launch-data/promotion-live-analysis',
				// 			},
				// 			{
				// 				name: '新建直播推广',
				// 				key: 'vhop/launch-data/createPromoteForm',
				// 			},
				// 			{
				// 				name: '详情',
				// 				key: 'vhop/launch-data/promotion-live-detail',
				// 			},
				// 			{
				// 				name: '计划包',
				// 				key: 'vhop/launch-data/promotion-live-plan',
				// 			},
				// 		],
				// 	},
				// 	{
				// 		name: '授权管理',
				// 		key: 'vhop/aide/auth',
				// 	},
				// ],


				
				// [
				// 	{
				// 		name: '合作商家',
				// 		key: 'troupe/supplier/supplier'
				// 	},
				// 	{
				// 		name: '合作商品',
				// 		key: 'troupe/supplier/supplier-goods'
				// 	}
				// ],
				
				[{
					name: '投放号管理',
					key: 'management/video-account'
				},
					{
						name: '团队管理',
						key: 'group',
						children: [
						  {
							name: '部门管理',
							key: 'management/dep',
						  },
						  {
							name: '员工管理',
							key: 'management/staff',
						  },
						],
					},
					{
						name: '操作日志',
						key: 'management/log'
					},

				],
				[
					{
						name: '会员服务',
						key: 'price/price'
					},
					{
						name: '会员服务',
						key: 'price/priceab'
					},
					{
						name: '购买会员',
						key: 'price/pay'
					}
				],
				[
					{
						name: '邀请奖励',
						key: 'invite/invite'
					},
					{
						name: '邀请奖励',
						key: 'invite/inviteab'
					}
				],
				
			]
		}
		if(role==2){
			returnData =
			[
			
				[
					{
						name: '首页',
						key: 'index/index'
					}
				],
				[
					{
						name: '加热大屏',
						key: 'short-video/video-screen/video-screen'
					},
					{
						name: '视频投流',
						key: 'short-video',
						children: [
							{
								name: '投放数据',
								key: 'short-video/launch-data/launch-data',
							},
							{
								name: '素材数据',
								key: 'short-video/material',
							},
							{
								name: '计划包',
								key: 'short-video/plan-package/plan-package',
							},
							{
								name: '创建计划',
								key: 'short-video/create-plan/create-plan',
							},
						
							{
								name: '投放记录',
								key: 'short-video/put-record/put-record',
							},
						],
					},
					{
						name: '批量创建',
						key: 'batchCreatePlan',
						children: [
							{
								name: '创建计划',
								key: 'short-video/batch-create-plan/batch-create-plan',
							},
							{
								name: '投放记录',
								key: 'short-video/batch-create-plan/batch-put-record',
							},
						],
					},
					{
						name: '长期计划',
						key: 'longTermPlan',
						children: [
							{
								name: '投放数据',
								key: 'short-video/long-term-plan/launch-data/launch-data',
							},
							{
								name: '素材数据',
								key: 'short-video/long-term-plan/material',
							},
							{
								name: '计划包',
								key: 'short-video/long-term-plan/plan-package/plan-package',
							},
							{
								name: '创建计划',
								key: 'short-video/long-term-plan/create-plan/create-plan',
							},
							{
								name: '投放记录',
								key: 'short-video/long-term-plan/put-record/put-record',
							}
						],
					},
					// {
					// 	name: '杠杆投流',
					// 	key: 'videoLever',
					// 	children: [
					// 		{
					// 			name: '创建杠杆',
					// 			key: 'short-video/bar/create-plan',
					// 		},
					// 		{
					// 			name: '杠杆记录',
					// 			key: 'short-video/bar/process',
					// 		},
							
					// 		{
					// 			name: '充值余额',
					// 			key: 'short-video/management/balance',
					// 		},
					// 		{
					// 			name: '余额明细',
					// 			key: 'short-video/management/balance-details',
					// 		},
					// 		{
					// 			name: '余额提现',
					// 			key: 'short-video/withdrawal/withdrawal',
					// 		},
							
						
					// 	],
					// },
					// {
					// 	name: '视频管理',
					// 	key: 'short-video/video-list/video-list'
					// },
					{
						name: '视频号助手',
						key: 'shortAide',
						children: [
							{
								name: '授权管理',
								key: 'short-video/aide/auth',
							},
							{
								name: '视频管理',
								key: 'short-video/aide/video-list',
							},
							{
								name: '自动删评',
								key: 'short-video/aide/auto-del',
							}
							
						],
					},
					{
						name: '数据报表',
						key: 'report',
						children: [
							{
								name: '财务报表',
								key: 'short-video/report/finance',
							},
							{
								name: '运营报表',
								key: 'short-video/report/operation',
							}
						],
					},
					{
						name: '投流订单',
						key: 'order',
						children: [
							{
								name: '订单管理',
								key: 'short-video/order/order-management',
							}
						],
					},
					{
						name: '智能助手',
						key: 'auto',
						children: [
							{
								name: '自动关停策略',
								key: 'short-video/auto-close/auto-close',
							}
						],
					}
				],
				[
					{
						name: '加热大屏',
						key: 'live/screen/screen'
					},
					
				
					{
					name: '直播投流',
					key: 'live',
					children: [
						{
							name: '投放数据',
							key: 'live/launch-data/launch-data',
						},
						{
							name: '智能赔付',
							key: 'live/compensation/compensation',
						},
						{
							name: '计划包',
							key: 'live/plan-package/plan-package',
						},
						{
							name: '创建计划',
							key: 'live/create-plan/create-plan',
						},
						{
							name: '投放记录',
							key: 'live/put-record/put-record',
						}
						
					],
				},
				{
					name: '直播大屏',
					key: 'assistant',
					children: [
						{
							name: '直播帐号',
							key: 'live/assistant1/assistant-account',
						},
						{
							name: '直播场次',
							key: 'live/assistant1/assistant-data',
						},
						
						{
							name: '数据大屏',
							key: 'live/assistant1/assistant-screen',
						},
					],
				},
				{
					name: '长期计划',
					key: 'promoteLive',
					children: [
						{
							name: '投放数据',
							key: 'live/promote-plan/launch-data/launch-data',
						},
				
						{
							name: '计划包',
							key: 'live/promote-plan/plan-package/plan-package',
						},
						{
							name: '创建计划',
							key: 'live/promote-plan/create-plan/create-plan',
						},
						{
							name: '投放记录',
							key: 'live/promote-plan/put-record/put-record',
						}
					
					],
				},
				{
					name: '数据报表',
					key: 'liveReport',
					children: [
						{
							name: '财务报表',
							key: 'live/report/finance',
						},
						// {
						// 	name: '运营报表',
						// 	key: 'short-video/report/operation',
						// }
					],
				},
				{
					name: '数据分析',
					key: 'live/data-analysis/data-analysis'
				},
				{
					name: '智能助手',
					key: 'liveAuto',
					children: [
						{
							name: '自动关停策略',
							key: 'live/auto-close/auto-close',
						}
					],
				},

				// {
				// 	name: '杠杆投流',
				// 	key: 'lever',
				// 	children: [
				
				// 		{
				// 			name: '创建杠杆',
				// 			key: 'live/lever/create-plan',
				// 		},
				// 		{
				// 			name: '杠杆记录',
				// 			key: 'live/lever/process',
				// 		},
				// 		{
				// 			name: '充值余额',
				// 			key: 'live/management/balance',
				// 		},
				// 		{
				// 			name: '余额明细',
				// 			key: 'live/management/balance-details',
				// 		},
				// 		{
				// 			name: '余额提现',
				// 			key: 'live/withdrawal/withdrawal',
				// 		},
				
				// 	],
				// }
				
				
				],
				[
					{
						name: '加热大屏',
						key: 'product-card/video-screen/video-screen'
					},
					{
						name: '商品卡投流',
						key: 'product-card',
						children: [
							{
								name: '投放数据',
								key: 'product-card/launch-data/launch-data',
							},
							{
								name: '素材数据',
								key: 'product-card/material/material',
							},
							{
								name: '计划包',
								key: 'product-card/plan-package/plan-package',
							},
							{
								name: '创建计划',
								key: 'product-card/create-plan/create-plan',
							},
							{
								name: '投放记录',
								key: 'product-card/put-record/put-record',
							},
						],
					},
					{
						name: '数据报表',
						key: 'productCardReport',
						children: [
							{
								name: '财务报表',
								key: 'product-card/report/finance',
							},
						],
					},
					{
						name: '智能助手',
						key: 'productCardAuto',
						children: [
							{
								name: '自动关停策略',
								key: 'product-card/auto-close/auto-close',
							},
						],
					},
				],
				[

					{
						name: '订单管理',
						key: 'shopManagement',
						children: [
							{
								name: '订单列表',
								key: 'shop/order-list/order-list',
							}
						],
					},
				
					// {
					// 	name: '商品管理',
					// 	key: 'shopGoodsManagement',
					// 	children: [
					// 		{
					// 			name: '商品数据统计',
					// 			key: 'shop/goods-management/goods-management',
					// 		}
							
					// 	],
					// },
				
				],
				// [
				// 	{
				// 		name: '商品推广',
				// 		key: 'vshopPromotionShop',
				// 		children: [
				// 			{
				// 				name: '推广数据',
				// 				key: 'vhop/launch-data/promotion-shop',
				// 			},
				// 			{
				// 				name: '详情',
				// 				key: 'vhop/launch-data/promotion-shop-detail',
				// 			},
				// 			{
				// 				name: '计划包',
				// 				key: 'vhop/launch-data/promotion-shop-plan',
				// 			},
							
				// 		],
				// 	},
				// 	{
				// 		name: '直播推广',
				// 		key: 'vshopPromotionLive',
				// 		children: [
				// 			{
				// 				name: '推广数据',
				// 				key: 'vhop/launch-data/promotion-live',
				// 			},
				// 			{
				// 				name: '数据分析',
				// 				key: 'vhop/launch-data/promotion-live-analysis',
				// 			},
				// 			{
				// 				name: '新建直播推广',
				// 				key: 'vhop/launch-data/createPromoteForm',
				// 			},
				// 			{
				// 				name: '详情',
				// 				key: 'vhop/launch-data/promotion-live-detail',
				// 			},
				// 			{
				// 				name: '计划包',
				// 				key: 'vhop/launch-data/promotion-live-plan',
				// 			},
				// 		],
				// 	},
				// 	{
				// 		name: '授权管理',
				// 		key: 'vhop/aide/auth',
				// 	},
				// ],



				// [
				// 	{
				// 		name: '合作商家',
				// 		key: 'troupe/supplier/supplier'
				// 	},
				// 	{
				// 		name: '合作商品',
				// 		key: 'troupe/supplier/supplier-goods'
				// 	}
				// ],
				[{
					name: '视频号管理',
					key: 'management/video-account'
				}

				],
				// [
				// 	{
				// 		name: '会员服务',
				// 		key: 'price/price'
				// 	},
				// 	{
				// 		name: '会员服务',
				// 		key: 'price/priceab'
				// 	},
				// 	{
				// 		name: '购买会员',
				// 		key: 'price/pay'
				// 	}
				// ],
			
			]
		}
		if(role==3){
			returnData =
			[
			
				[
					{
						name: '首页',
						key: 'index/index'
					}
				],

				[
					{
						name: '直播投流',
						key: 'live',
						children: [
							{
								name: '短视频数据',
								key: 'short-video/launch-data/launch-data',
							},
							{
								name: '直播数据',
								key: 'live/launch-data/launch-data',
							}
							
							
						],
					},
					// {
					// 	name: '杠杆投流',
					// 	key: 'lever',
					// 	children: [
					// 		{
					// 			name: '直播审核',
					// 			key: 'live/lever/process',
					// 		},
					// 		{
					// 			name: '视频审核',
					// 			key: 'short-video/bar/process',
					// 		},
					// 		{
					// 			name: '余额明细',
					// 			key: 'live/management/balance-details',
					// 		}
					
					// 	],
					// }
				
				],

				
				[{
					name: '视频号管理',
					key: 'management/video-account'
				},
					
				{
					name: '操作日志',
					key: 'management/log'
				}

				]
			]
		}
	  
	  return returnData;
	}